import { atom, selector } from 'recoil';
import { Services } from '@/types/api/mypage/serviceInfo';
import persistAtom from './recoilPersist';

/**
 * 契約サービス情報の state。
 * ユーザーが契約している全サービス（光・モバイル等）の一覧を保持し、サービス選択やサービス別トップ表示の基礎データにする。
 */
export const serviceInfoState = atom<Services[]>({
  key: 'serviceInfoState',
  default: [],
  effects_UNSTABLE: [persistAtom],
});

/**
 * 現在選択中のサービスIDの state。
 * 複数契約時に、どの契約を対象にAPIや画面を動かすかをこの値で確定させる。
 */
export const serviceIdState = atom<string>({
  key: 'serviceIdState',
  default: '',
  effects_UNSTABLE: [persistAtom],
});

/** モバイル選択中サービスの電話番号を保持する state。 */
export const serviceMobileSimPhoneNumberState = atom<string>({
  key: 'serviceMobileSimPhoneNumberState',
  default: '',
  effects_UNSTABLE: [persistAtom],
});

/** 光とモバイルのサービス連携状態を保持する state。 */
export const serviceLinkState = atom<boolean>({
  key: 'serviceLinkState',
  default: false,
  effects_UNSTABLE: [persistAtom],
});

/** パスワード設定者情報を保持する state。null の場合は未設定。 */
export const passwordSetterState = atom<string | null>({
  key: 'passwordSetterState',
  default: null,
  effects_UNSTABLE: [persistAtom],
});

/**
 * 契約サービス一覧と選択中サービスIDから、現在対象の契約種別だけを取り出す selector。
 * 画面側が毎回一覧検索しなくて済むように、よく使う派生値をここでまとめる。
 */
export const serviceInfoStateContractTypeSelector = selector({
  key: 'service_info_state_contract_type_selector',
  get: ({ get }): string | undefined => {
    // 選択中サービスが未確定なら契約種別も判定できないため undefined を返す。
    const serviceId = get(serviceIdState);
    if (!serviceId) {
      return undefined;
    }

    // 一覧の中から現在対象のサービスだけを抜き出して契約種別を返す。
    const infos = get(serviceInfoState) ?? [];
    const info = infos.find((item) => {
      if (serviceId === item.service_id) {
        return true;
      }
      return false;
    });

    if (!info) {
      return undefined;
    }
    return info.contract_type;
  },
});
